import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/home',
      name: 'home',
      redirect: 'users',
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login'),
      meta: {
        template: () => import('./templates/Authorisation.vue'),
      },
    },
    {
      path: '/password/forgotten',
      name: 'password.forgotten',
      component: () => import('./views/PasswordForgotten.vue'),
      meta: {
        template: () => import('./templates/Authorisation.vue'),
      },
    },
    {
      path: '/password/reset/:token',
      name: 'password.reset',
      component: () => import('./views/PasswordReset.vue'),
      meta: {
        template: () => import('./templates/Authorisation.vue'),
      },
    },
    {
      path: '/invitation/accept/:token',
      name: 'invitation.accept',
      component: () => import('./views/InvitationAccept.vue'),
      meta: {
        template: () => import('./templates/Authorisation.vue'),
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/Profile.vue'),
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('./views/UserResource.vue'),
    },
    {
      path: '/timeline',
      name: 'timeline',
      component: () => import('./views/Timeline.vue'),
    },
    {
      path: '/beacons',
      name: 'beacons',
      component: () => import('./views/Beacons.vue'),
    },
    {
      path: '/manufacturers',
      name: 'manufacturers',
      component: () => import('./views/ManufacturerResource.vue'),
    },
    {
      path: '/organisations',
      name: 'organisations',
      component: () => import('./views/OrganisationResource.vue'),
    },
    {
      path: '/third-parties',
      name: 'third-parties',
      component: () => import('./views/ThirdPartyResource.vue'),
    },

  ],
});
